"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEACHER_RACE_OPTIONS = exports.TEACHER_ETHNICITY_OPTIONS = void 0;
// registration data
const TEACHER_ETHNICITY_OPTIONS = [{
  label: 'No, not of Hispanic, Latino, or Spanish Origin',
  value: '17',
  singleSelect: true
}, {
  label: 'Yes, Cuban',
  value: '14'
}, {
  label: 'Yes, Mexican',
  value: '5'
}, {
  label: 'Yes, Puerto Rican',
  value: '6'
}, {
  label: 'Yes, another Hispanic, Latino, or Spanish Origin',
  value: '7'
}, {
  label: 'I do not wish to respond',
  value: '15',
  singleSelect: true
}];
exports.TEACHER_ETHNICITY_OPTIONS = TEACHER_ETHNICITY_OPTIONS;
const TEACHER_RACE_OPTIONS = {
  asian: {
    label: 'Asian (including Indian sub-continent and Philippines origin)',
    value: '2'
  },
  black: {
    label: 'Black or African American (including Africa and Afro-Caribbean origin)',
    value: '3'
  },
  nativeAmerican: {
    label: 'Native American or Alaska Native',
    value: '1'
  },
  pacificIslander: {
    label: 'Native Hawaiian or other Pacific Islander',
    value: '8'
  },
  white: {
    label: 'White (including Middle Eastern origin)',
    value: '9'
  },
  noResponse: {
    label: 'I do not wish to respond',
    value: '0',
    singleSelect: true
  }
};
exports.TEACHER_RACE_OPTIONS = TEACHER_RACE_OPTIONS;